import { availableLanguages } from "../../common/parameters";

import { getItem, setItem } from "../cookie";
import { IUser } from "../store/user/models";

export default () => {
    let language = "en-us";
    const query1 = window.location.search.replace("?", "").split("&")?.[0];
    const query2 = window.location.search.replace("?", "").split("&")?.[1];
    if (query1 && query1.includes("lang") && query2 === "nativeApp=1") {
        const locale = query1.slice(5);
        if (availableLanguages.includes(locale)) {
            return locale;
        }
    }
    if ((window.INITIAL_STATE?.user as IUser)?.language) {
        language = (window.INITIAL_STATE.user as IUser).language;
    } else {
        let cookieLanguage = getItem("language");
        if (cookieLanguage && availableLanguages.indexOf(cookieLanguage) === -1) {
            cookieLanguage = "en-us";
        }
        if (cookieLanguage === "en") {
            cookieLanguage = "en-us";
            setItem("language", language, 60 * 60 * 24 * 365);
        }
        if (!cookieLanguage) {
            language = "en-us";
            for (let lang of availableLanguages) {
                if (window.navigator && window.navigator.language.toLowerCase().indexOf(lang) !== -1) {
                    language = lang;
                    if (
                        window.navigator.language.toLowerCase() === "zh-hk" ||
                        window.navigator.language.toLowerCase() === "zh-tw"
                    ) {
                        language = "zh-hant";
                    }
                    break;
                }
            }
        } else {
            language = cookieLanguage;
        }
    }
    return language;
};
